import React, { SVGProps } from 'react'
const SvgNoUsersGrayscale = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={83}
    height={75}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g clipPath="url(#No-Users-Grayscale_svg__a)">
      <path
        fill="#EAEBF1"
        fillRule="evenodd"
        d="M73.704 8H61.207C60.54 8 60 8.54 60 9.207v1.69c0 .666.54 1.206 1.207 1.206h12.497c.667 0 1.207-.54 1.207-1.206v-1.69C74.91 8.54 74.37 8 73.704 8ZM78.704 44H46.207C45.54 44 45 44.54 45 45.207v1.69c0 .666.54 1.206 1.207 1.206h32.497c.667 0 1.207-.54 1.207-1.206v-1.69c0-.667-.54-1.207-1.207-1.207ZM26.704 51H4.207C3.54 51 3 51.54 3 52.207v1.69c0 .666.54 1.206 1.207 1.206h22.497c.666 0 1.207-.54 1.207-1.206v-1.69c0-.667-.54-1.207-1.207-1.207Z"
        clipRule="evenodd"
      />
      <g filter="url(#No-Users-Grayscale_svg__b)">
        <path
          fill="#000"
          d="M42.5 70C61.554 70 77 54.33 77 35S61.554 0 42.5 0C23.446 0 8 15.67 8 35s15.446 35 34.5 35Z"
        />
      </g>
      <path
        fill="#FCFCFF"
        d="M42.5 70C61.554 70 77 54.33 77 35S61.554 0 42.5 0C23.446 0 8 15.67 8 35s15.446 35 34.5 35Z"
      />
      <mask
        id="No-Users-Grayscale_svg__c"
        width={69}
        height={70}
        x={8}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M42.5 70C61.554 70 77 54.33 77 35S61.554 0 42.5 0C23.446 0 8 15.67 8 35s15.446 35 34.5 35Z"
        />
      </mask>
      <g mask="url(#No-Users-Grayscale_svg__c)">
        <g filter="url(#No-Users-Grayscale_svg__d)">
          <path
            fill="#000"
            d="M5.18 68.15C1.424 51.221 7.055 42.758 22.072 42.758c15.016 0 20.647 8.463 16.893 25.39"
          />
        </g>
        <path
          fill={props.fill || '#697080'}
          d="M5.18 68.15C1.424 51.221 7.055 42.758 22.072 42.758c15.016 0 20.647 8.463 16.893 25.39"
        />
        <g filter="url(#No-Users-Grayscale_svg__e)">
          <path
            fill="#000"
            d="M22.072 45.43c5.972 0 10.812-4.882 10.812-10.905 0-6.022-4.84-10.904-10.812-10.904-5.97 0-10.811 4.882-10.811 10.904 0 6.023 4.84 10.905 10.811 10.905Z"
          />
        </g>
        <path
          fill="#DADBE0"
          d="M22.072 45.43c5.972 0 10.812-4.882 10.812-10.905 0-6.022-4.84-10.904-10.812-10.904-5.97 0-10.811 4.882-10.811 10.904 0 6.023 4.84 10.905 10.811 10.905Z"
        />
      </g>
      <mask
        id="No-Users-Grayscale_svg__f"
        width={69}
        height={70}
        x={8}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M42.5 70C61.554 70 77 54.33 77 35S61.554 0 42.5 0C23.446 0 8 15.67 8 35s15.446 35 34.5 35Z"
        />
      </mask>
      <g mask="url(#No-Users-Grayscale_svg__f)">
        <g filter="url(#No-Users-Grayscale_svg__g)">
          <path
            fill="#000"
            d="M59.445 59.25c-2.69-12.091 1.345-18.137 12.107-18.137 10.761 0 14.797 6.046 12.107 18.136"
          />
        </g>
        <path
          fill="#BDC1C8"
          d="M59.445 59.25c-2.69-12.091 1.345-18.137 12.107-18.137 10.761 0 14.797 6.046 12.107 18.136"
        />
        <g filter="url(#No-Users-Grayscale_svg__h)">
          <path
            fill="#000"
            d="M71.552 43.307c4.28 0 7.748-3.487 7.748-7.789s-3.469-7.789-7.748-7.789c-4.28 0-7.749 3.487-7.749 7.79 0 4.3 3.47 7.788 7.749 7.788Z"
          />
        </g>
        <path
          fill="#D8DADE"
          d="M71.552 43.307c4.28 0 7.748-3.487 7.748-7.789s-3.469-7.789-7.748-7.789c-4.28 0-7.749 3.487-7.749 7.79 0 4.3 3.47 7.788 7.749 7.788Z"
        />
      </g>
      <mask
        id="No-Users-Grayscale_svg__i"
        width={69}
        height={70}
        x={8}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          d="M42.5 70C61.554 70 77 54.33 77 35S61.554 0 42.5 0C23.446 0 8 15.67 8 35s15.446 35 34.5 35Z"
        />
      </mask>
      <g mask="url(#No-Users-Grayscale_svg__i)">
        <g filter="url(#No-Users-Grayscale_svg__j)">
          <path
            fill="#000"
            d="M19.231 78.514c-5.193-23.456 2.597-35.184 23.37-35.184 20.772 0 28.561 11.728 23.368 35.184"
          />
        </g>
        <path
          fill={props.fill || '#B3B7BE'}
          d="M19.231 78.514c-5.193-23.456 2.597-35.184 23.37-35.184 20.772 0 28.561 11.728 23.368 35.184"
        />
        <g filter="url(#No-Users-Grayscale_svg__k)">
          <path
            fill="#000"
            d="M42.6 45.646c8.26 0 14.956-6.766 14.956-15.11 0-8.346-6.696-15.111-14.956-15.111s-14.956 6.765-14.956 15.11c0 8.345 6.696 15.11 14.956 15.11Z"
          />
        </g>
        <path
          fill={props.fill || '#B3B7BE'}
          d="M42.6 45.646c8.26 0 14.956-6.766 14.956-15.11 0-8.346-6.696-15.111-14.956-15.111s-14.956 6.765-14.956 15.11c0 8.345 6.696 15.11 14.956 15.11Z"
        />
      </g>
      <g
        stroke="#697080"
        strokeWidth={4}
        filter="url(#No-Users-Grayscale_svg__l)"
      >
        <path
          fill="#DADBE0"
          d="M53.333 59.667c8.469 0 15.334-6.865 15.334-15.334C68.667 35.865 61.802 29 53.333 29 44.865 29 38 35.865 38 44.333c0 8.469 6.865 15.334 15.333 15.334Z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m63.82 55.82 15.762 15.762"
        />
      </g>
    </g>
    <defs>
      <filter
        id="No-Users-Grayscale_svg__b"
        width={79}
        height={80}
        x={3}
        y={-4}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_233"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_233"
          result="shape"
        />
      </filter>
      <filter
        id="No-Users-Grayscale_svg__d"
        width={44.039}
        height={33.391}
        x={0.053}
        y={39.759}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_233"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_233"
          result="shape"
        />
      </filter>
      <filter
        id="No-Users-Grayscale_svg__e"
        width={29.623}
        height={29.809}
        x={7.261}
        y={20.621}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_233"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_233"
          result="shape"
        />
      </filter>
      <filter
        id="No-Users-Grayscale_svg__g"
        width={31.828}
        height={24.136}
        x={55.638}
        y={39.113}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_233"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_233"
          result="shape"
        />
      </filter>
      <filter
        id="No-Users-Grayscale_svg__h"
        width={21.497}
        height={21.578}
        x={60.803}
        y={25.729}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_233"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_233"
          result="shape"
        />
      </filter>
      <filter
        id="No-Users-Grayscale_svg__j"
        width={59.854}
        height={45.184}
        x={12.673}
        y={40.33}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_233"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_233"
          result="shape"
        />
      </filter>
      <filter
        id="No-Users-Grayscale_svg__k"
        width={39.912}
        height={40.221}
        x={22.644}
        y={12.425}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_233"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_233"
          result="shape"
        />
      </filter>
      <filter
        id="No-Users-Grayscale_svg__l"
        width={59.582}
        height={60.582}
        x={29}
        y={23}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1123_233"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1123_233"
          result="shape"
        />
      </filter>
      <clipPath id="No-Users-Grayscale_svg__a">
        <path fill="#fff" d="M0 0h83v75H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgNoUsersGrayscale
